/*=========================================================================================
  File Name: moduleClientGetters.js
  Description: Client Module Getters
==========================================================================================*/


export default {
    getClient: state => state.client,
    getClients: state => state.clients,
    getClienti: state => clientId => state.clients.find((client) => client.clid == clientId),
}
